// extracted by mini-css-extract-plugin
export default {"option":"Post_option__-v7vG","ans":"Post_ans__62zed","checkbox":"Post_checkbox__thUhy","ques":"Post_ques__3uvry"};